import React, { useEffect } from 'react';
import { vars } from '@croquiscom-pvt/zds-tokens';
import styled from '@emotion/styled';

import { Portal } from '../../portal/Portal';

interface Props {
  duration?: number;
  onClose: () => void;
}

export const ToastPopup: React.FC<React.PropsWithChildren<Props>> = ({ children, duration = 2000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Portal>
      <Container>
        <Dimmed onClick={onClose} />
        <ContentWrapper>{children}</ContentWrapper>
      </Container>
    </Portal>
  );
};

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dimmed = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(73, 80, 87, 0.7);
  transition: opacity 0.2s ease;
`;

const ContentWrapper = styled.div`
  max-width: 273px;
  padding: 20px;
  border-radius: 16px;
  z-index: 100;
  background-color: ${vars.color.staticWhite};
`;
